<template>
  <section :style="{ 'background-color': $theme.grey }" style="margin-bottom: 6rem;">
    <div class="row LP-header">
      <div class="col">
        <div class="container">
          <h1 style="font-weight: normal;" class="display-4">
            <i class="fa fa-certificate" aria-hidden="true"></i>
            Mortgage Loan
            <small class="text-muted">/ Agreements</small>
          </h1>
          <div class="col">
            <base-progress
              v-if="progress != 0"
              style="padding: 0; margin-top: 20px;margin-bottom: -30px;"
              type="success"
              :value="progress"
              :showPercent="false"
            ></base-progress>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div
        class="row shape shape-style-1 shape-primary shape-skew alpha-4"
        style="margin: 40px 0 4rem"
      >
        <div class="col">
          <template v-if="curAgreement">
            <h5>
              {{ curAgreement.Name }}
              <i
                v-if="curAgreement.HelpText"
                class="fa fa-info-circle text-info info"
                aria-hidden="true"
                v-b-popover.hover.top="curAgreement.HelpText"
              ></i>
            </h5>
            <p style="max-height: 200px;overflow: scroll;" v-html="curAgreement.Text"></p>
            <div style="margin-top: 2rem">
              <base-radio
                name="Agree"
                class="mb-3"
                v-model="curAgreement.value"
                :valid="agValid"
              >
                <b>I Agree</b> - to the {{ curAgreement.Name }}
              </base-radio>
              <base-radio
                name="Disagree"
                class="mb-3"
                v-model="curAgreement.value"
                :valid="agValid"
              >
                <b>I Disagree</b> - to the {{ curAgreement.Name }}
              </base-radio>
            </div>

            <div>
              <base-button
                type="primary"
                style="margin-top: 20px;"
                @click="nextAgreement"
                >Next</base-button
              >
            </div>
          </template>
        </div>
      </div>
    </div>
    <modal :show.sync="disagree">
      <template slot="header">
        <h5 class="modal-title text-warning" id="exampleModalLabel">
          Attention
        </h5>
      </template>
      <div>
        <p>
          In order to complete an online application, you must agree to this
          disclosure. If you do not wish to agree to these terms, please close
          this window and contact one of our staff members to assist you over
          the phone.
        </p>
      </div>
      <template slot="footer">
        <base-button outline type="secondary" @click="disagree = false"
          >Close</base-button
        >
      </template>
    </modal>
  </section>
</template>

<script>
import BaseRadio from "../components/BaseRadio.vue";
import "flatpickr/dist/flatpickr.css";
import {
  getAllAgreements,
  saveNewApplication,
  saveApplication,
  getApplication,
} from "../services/application";
import { success } from "../services/message";
import { assignOfficer } from "../services/officers.js";
export default {
  components: { BaseRadio },
  name: "application",
  data() {
    return {
      id: null,
      progress: 0,
      subTitle: "",
      app: {},
      agreements: [],
      curAgreement: false,
      agValid: null,
      cbType: false,
      cobType: false,
      disagree: false,
      info: this.$theme.info

    };
  },
  async created() {
    window.addEventListener("theme", () => {
      this.info = this.$theme.info;
    });
    // If "new" it is a new application, if ID then get the application.
    if (this.$route.params.id !== "new") {
      this.id = this.$route.params.id;
      let res = await getApplication(this.id);
      this.cobType = res.coBorrower;
      if (res.status === 200 && res.LoanAppJSON) {
        this.app = res.LoanAppJSON;
        this.getAgreements();
      } else if (res.status === 200) {
        this.getAgreements();
      } else {
        this.$router.push("/");
        // TODO: popup alert
      }
    } else {
      // TODO: check for current loan app before starting a new one.
      this.getAgreements();
    }
  },
  methods: {
    /**
     * Get all agreements, Do a check to see if any agreements have not be seen.
     */
    async getAgreements() {
      this.agreements = await getAllAgreements(1);

      if (this.app.agreements) {
        for (let i = 0; i < this.agreements.length; i++) {
          const a = this.agreements[i];

          if (!this.app.agreements[a.NameID]) {
            this.curAgreement = a;
            this.curAgreement.index = i;
            this.subTitle = "Agreements";
            break;
          }
          this.progress = Math.round(((i + 1) / this.agreements.length) * 100);
          if (!this.app.progress) {
            this.app.progress = {
              sections: {
                agreements: { progress: 0, agreement: 0 },
                fields: { progress: 0, page: null, pages: [] },
                coBorrower: { progress: 0, page: null },
                documents: { progress: 0, page: null },
              },
            };
          } else {
            this.app.progress.sections.agreements.progress = this.progress;
            this.app.progress.sections.agreements.agreement = i;
          }
        }

        if (this.progress === 100) {
          this.progress = 0;
          if (this.cobType) {
            this.$router.push(`/application/${this.$route.params.id}/fields`);
          } else {
            this.$router.push(
              `/application/${this.$route.params.id}/co-borrower`
            );
          }
        }
      } else {
        this.app.agreements = {};
        this.curAgreement = this.agreements[0];
        this.curAgreement.index = 0;
        if (!this.app.progress) {
          this.app.progress = {
            sections: {
              agreements: { progress: 0, agreement: 0 },
              coBorrower: { progress: 0 },
              fields: { progress: 0, page: null, pages: [] },
              documents: { progress: 0, page: null },
            },
          };
        }
      }
    },
    /**
     * Process to the next agreement and save()
     */
    async nextAgreement() {
      if (!this.curAgreement.value) {
        this.agValid = false;
        setTimeout(() => {
          this.agValid = null;
        }, 1000);
        return;
      } else if (this.curAgreement.value != "Agree") {
        this.disagree = true;
        return;
      }

      this.app.agreements[this.curAgreement.NameID] = this.curAgreement.value;

      await this.save(this.curAgreement.ID);

      if (this.curAgreement.index < this.agreements.length - 1) {
        let ind = this.curAgreement.index;
        this.curAgreement = this.agreements[ind + 1];
        this.curAgreement.index = ind + 1;
        this.progress = Math.round(
          (this.curAgreement.index / this.agreements.length) * 100
        );
        this.app.progress.sections.agreements.progress = this.progress;
        this.app.progress.sections.agreements.agreement = ind + 1;
      } else {
        this.progress = 100;
        this.app.progress.sections.agreements.progress = this.progress;
        setTimeout(async () => {
          this.curAgreement = false;
          await this.save(this.curAgreement.ID);
          if (this.cobType) {
            this.$router.push(`/application/${this.$route.params.id}/fields`);
          } else {
            let referral = window.sessionStorage.getItem("referral");

            if (referral) {
              await assignOfficer(this.$route.params.id, referral);
              this.$router.push(
                `/application/${this.$route.params.id}/co-borrower`
              );
            } else {
              this.$router.push(
                `/application/${this.$route.params.id}/officer`
              );
            }
          }
        }, 500);
      }
    },
    /**
     * Save loan application, this should be call with any change
     */
    async save(id) {
      if (this.$route.params.id && this.$route.params.id !== "new") {
        let res = await saveApplication(this.$route.params.id, this.app, id);
        this.app = res.app;
      } else {
        let res = await saveNewApplication(this.app, id);
        this.$router.push({
          name: "agreements",
          params: { id: res.loanAppID },
        });
        this.app = res.app;
      }
      success("Agreements Saved");
    },
  },
};
</script>
